import "./bootstrap";
import React from "react";
import { InertiaProgress } from "@inertiajs/progress";
import { createInertiaApp } from "@inertiajs/inertia-react";
import { createRoot } from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB";
import { PayloadProvider } from "@/Contexts/PayloadContext";
import * as Sentry from "@sentry/react";

registerLocale("en-GB", enGB);
setDefaultLocale("en-GB");

InertiaProgress.init({
  color: "#a5f3fC",
});

if (process?.env?.MIX_SENTRY_DSN_PUBLIC) {
  Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
  });
}

createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),
  setup({ el, App, props }) {
    createRoot(el).render(
      <PayloadProvider>
        <App {...props} />
        <ToastContainer
          autoClose={5000}
          closeOnClick={true}
          pauseOnFocusLoss={true}
          pauseOnHover={true}
        />
      </PayloadProvider>,
    );
  },
});

// Disable mousewheel scroll on number inputs
document.addEventListener("wheel", function (event) {
  if (document.activeElement.type === "number") {
    document.activeElement.blur();
  }
});
